import { getLanguage } from './getLanguage';

export const getLanguageKey = (): string | undefined => {
  const LOCAL_STORAGE_KEY = 'mage-cache-storage';
  const langKey = getLanguage();
  const region = ENVIRONMENT_REGION || 'US';

  if (langKey) {
    return `${langKey}-${region}`;
  }

  const localData = window.localStorage.getItem(LOCAL_STORAGE_KEY);

  if (localData) {
    try {
      const parsedData = JSON.parse(localData);
      return `${parsedData?.lang?.locale}-${region}`;
    } catch (e) {
      console.error('Malformed localStorage data:', e);
    }
  }

  return 'en-US';
};
